import React from 'react'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import CodigoResgate from '../../../components/CodigoResgate/CodigoResgate'
import { useAssinaturaPresente } from '../../../contexts/AssinaturaPresenteContext'
import { isEmptyObject } from '../../../utils/helpers/helpers'

const Destaque = styled.span`
  color: ${StyleGuide.cores.azul};
  font-weight: bold;
`

const Titulo = styled.h1`
  ${StyleGuide.tipografia.titulo1};
  margin: 25px 0 22px 0;
`

const Subtitulo = styled.div`
  margin-bottom: 20px;

  p {
    ${StyleGuide.tipografia.textoDefault};
    margin: 0;
  }
`

const Resgate = () => {
  const {
    codigoResgate,
    dadosAssinaturaPresente,
    erroCodigo,
    resgatarPresente,
    onChangeCodigo,
  } = useAssinaturaPresente()

  const nroKits = !isEmptyObject( dadosAssinaturaPresente )
    ? dadosAssinaturaPresente.presente.plano.totalKits
    : 0

  return (
    <>
      <Titulo>
        Resgatar presente
      </Titulo>

      <Subtitulo>
        <p><Destaque>Atenção:</Destaque> o presente deve ser resgatado <strong>pela pessoa que foi presenteada.</strong></p>

        <p>Caso você tenha presenteado um amigo, é ele quem fará o resgate.</p>
      </Subtitulo>

      <CodigoResgate
        codigoResgate={ codigoResgate }
        dadosAssinaturaPresente={ dadosAssinaturaPresente }
        erroCodigo={ erroCodigo }
        onChangeCodigo={ onChangeCodigo }
        onClick={ resgatarPresente }
        periodo={ nroKits }
      />
    </>
  )
}

export default Resgate
